import { CoreClientApiTags, coreApi } from '@cp/shared/api/core';
import { ClientContactUpdateRequest, ClientContactViewModel, ClientContactsDictionary } from '@common/model/client';
import { ApiRoutePathParams } from '@common/api/routePathParams';
import { ApiRoute } from '@common/api/route';
import { generateApiUrl } from '@common/api/configure';
import { apiRouteMethodDict } from '@common/api/routeMethod';
import { ClientContactsResponse } from '@common/model/client/contact/clientContactsResponse';
import { clientContactsListDataAdaptor } from './adaptor';
import { CoreClientContactApiTags, coreClientContactApiTagTypes } from './tags';

export const coreClientContactApi = coreApi
  .enhanceEndpoints({
    addTagTypes: coreClientContactApiTagTypes,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getContacts: builder.query<ClientContactsDictionary, void>({
        query: () => ({
          url: 'client/contacts',
        }),
        transformResponse: (response: ClientContactViewModel[], _meta, _arg) => {
          return clientContactsListDataAdaptor(response);
        },
        providesTags: [CoreClientContactApiTags.ClientContactList],
      }),

      updateContact: builder.mutation<void, ClientContactUpdateRequest>({
        query: (parameters) => ({
          method: 'PUT',
          url: 'client/contacts',
          body: parameters,
        }),
        invalidatesTags: [CoreClientContactApiTags.ClientContactList, CoreClientApiTags.ClientProfile],
      }),

      canView: builder.query<boolean, ApiRoutePathParams[ApiRoute.ClientsContactCanView]>({
        query: (params) => ({
          url: generateApiUrl(ApiRoute.ClientsContactCanView, params),
          method: apiRouteMethodDict[ApiRoute.ClientsContactCanView],
        }),
        transformResponse: (res: '1' | '0') => Boolean(Number.parseInt(res)),
        providesTags: (_res, _err, req) => [{ type: CoreClientContactApiTags.ClientContactCanView, id: req.clientId }],
      }),

      canOpen: builder.query<boolean, ApiRoutePathParams[ApiRoute.ClientsContactCanOpen]>({
        query: (params) => ({
          url: generateApiUrl(ApiRoute.ClientsContactCanOpen, params),
          method: apiRouteMethodDict[ApiRoute.ClientsContactCanOpen],
        }),
        transformResponse: (res: '1' | '0') => Boolean(Number.parseInt(res)),
        providesTags: (_res, _err, req) => [{ type: CoreClientContactApiTags.ClientContactCanOpen, id: req.clientId }],
      }),

      getAnotherClientContacts: builder.query<ClientContactsResponse, ApiRoutePathParams[ApiRoute.ClientsContactGet]>({
        query: (params) => ({
          url: generateApiUrl(ApiRoute.ClientsContactGet, params),
          method: apiRouteMethodDict[ApiRoute.ClientsContactGet],
        }),
        providesTags: (_res, _err, req) => [
          {
            type: CoreClientContactApiTags.AnotherClientContactList,
            id: req.clientId,
          },
        ],
      }),
    }),

    overrideExisting: false,
  });
